import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { YoutubePlayerComponent } from './youtube-player.component';

@NgModule({
  declarations: [YoutubePlayerComponent],
  imports: [CommonModule],
  exports: [YoutubePlayerComponent],
})
export class YoutubePlayerModule {}
